import { VAlert } from 'vuetify/lib/components/VAlert';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.alerts),function(alert,index){return _c(VAlert,{key:alert.id,class:{ 'mt-2': index > 1 },attrs:{"type":alert.type,"dismissible":"","border":"left","colored-border":""},on:{"input":function($event){return _vm.alerts.splice(index, 1)}}},[_vm._v("\n\t\t"+_vm._s(alert.message)+"\n\t")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }